.ControlBase1631115975__root {
  -st-states: hasHeader,
    alignment(enum(horizontal, vertical, vertical-narrow));

  display: flex;
  flex-direction: column;
}

.ControlBase1631115975__controlWrapper:focus-visible {
  outline: 2px solid #80b1ff;
}

.ControlBase1631115975__root.ControlBase1631115975---alignment-15-vertical-narrow.ControlBase1631115975--hasHeader {
  gap: 6px;
}

.ControlBase1631115975__root.ControlBase1631115975---alignment-8-vertical,
.ControlBase1631115975__root.ControlBase1631115975---alignment-10-horizontal {
  gap: 12px;
}

.ControlBase1631115975__root.ControlBase1631115975---alignment-8-vertical.ControlBase1631115975--hasHeader, 
.ControlBase1631115975__root.ControlBase1631115975---alignment-15-vertical-narrow.ControlBase1631115975--hasHeader {
  padding: 12px 24px 18px;
}

.ControlBase1631115975__root.ControlBase1631115975---alignment-8-vertical:not(hasHeader),
.ControlBase1631115975__root.ControlBase1631115975---alignment-15-vertical-narrow:not(hasHeader) {
  padding: 18px 24px;
}

.ControlBase1631115975__root.ControlBase1631115975---alignment-10-horizontal {
  padding: 12px 24px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.ControlBase1631115975__divider {
  display: flex;
  -st-states: size(enum(long, short));
  height: 1px;
  background: #dfe5eb;
  margin: 0 auto;
}

.ControlBase1631115975__divider.ControlBase1631115975---size-5-short {
  margin: 0 24px;
}

/* st-namespace-reference="../../../../src/controls/ControlBase/ControlBase.st.css" */